<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card>
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
          <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <div class="pa-3">
          <div class="grid_half">
            <div class="mt-3 mr-1">
              <div class="enddate_sale_report ml-1">
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable color="#86bc3a" v-model="date" label="วันที่สั่งซื้อ (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่สั่งซื้อ']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="mt-3 ml-1">
              <v-autocomplete color="#86bc3a" :items="getProduct"  item-text="name" item-value="id" @input="addPurchase(id_product)"  v-model="id_product" label="ค้นหาสินค้าเพิ่มในใบสั่งซื้อ" prepend-inner-icon="mdi-archive" hide-details="auto" outlined></v-autocomplete>
            </div>
          </div>
          <v-form ref="save_list" @submit.prevent="store_productList">
            <div class="pa-2">
              <div class="d-flex justify-space-between align-center">
                <h3>รายการสินค้าที่จะสั่งซื้อ</h3>
                <v-btn 
                  v-if="purchase_list.length > 0" 
                  small 
                  color="error" 
                  outlined 
                  @click="clearAllData"
                  class="ml-2"
                >
                  <v-icon small left>mdi-delete-sweep</v-icon>
                  ล้างข้อมูลทั้งหมด
                </v-btn>
              </div>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              <v-data-table :headers="purchaseHeaders" :items="purchase_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr class="table_responsive">
                    <td><v-checkbox color="#86bc3a" v-model="dataDetail.item.status_credit"/></td>
                    <td>{{ dataDetail.item.product_code }}</td>
                    <td>
                      <div @click="ChangeInput(dataDetail.item.loop_id)" v-if="dataDetail.item.show_input == 0">{{ dataDetail.item.name }}</div>
                      <v-text-field @blur="ChangeInput(dataDetail.item.loop_id)" color="#86bc3a" v-model="dataDetail.item.name" v-if="dataDetail.item.show_input == 1" class="input_width" label="ชื่อสินค้า" hide-details="auto" outlined></v-text-field>
                    </td>
                    <td class="pa-3">
                      <v-btn small type="button" height="42" @click="getHistory(dataDetail.item.loop_id, dataDetail.item.product_id, dataDetail.item.product_code, dataDetail.item.name)" class="grad-success-bg white--text mr-1 mb-1">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <div class="ma-3 mr-1">
                        <v-select color="#86bc3a" class="input_width" :items="dataDetail.item.product_lists" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" item-text="unit_name" item-value="unit_id" v-model="dataDetail.item.units" label="หน่วยนับ" hide-details="auto" outlined @change="updatePriceByUnit(dataDetail.item)"></v-select>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 mr-1">
                        <v-select color="#86bc3a" class="input_width_com" :items="dataDetail.item.product_suppliers" :rules="[v => !!v || 'กรุณาเลือกบริษัท']" item-text="sup_name_department" item-value="sup_id" v-model="dataDetail.item.supplier" label="ชื่อบริษัท" hide-details="auto" outlined></v-select>
                      </div>
                    </td>
                    <td class="pa-3">
                      <div v-if="dataDetail.item.supplier !== null">
                        <v-btn small type="button" height="42" @click="getCompany(dataDetail.item.supplier)" class="grad-warning-bg white--text mr-1 mb-1">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-btn small type="button" height="42" class="grad-grey-bg white--text mr-1 mb-1" disabled>
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td>{{ dataDetail.item.count_warehouse }}</td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" :rules="[v => !!v && v > 0 && v > '0' || 'กรุณากรอกจำนวนและต้องมากกว่า 0']" min="0" @keypress="isOnlyNumber($event)" class="input_width" label="จำนวน" hide-details="auto" v-model="dataDetail.item.amount" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" :rules="[v => (v === 0 || v === '0' || (v !== null && v !== undefined && v !== '')) || 'กรุณากรอกราคา']" min="0" @keypress="isCurrency($event, dataDetail.item.price)" class="input_width" label="ราคา" hide-details="auto" v-model="dataDetail.item.price" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" min="0" @keypress="isCurrency($event, dataDetail.item.discount_unit)" class="input_width" label="ส่วนลด(บาท)" hide-details="auto" v-model="dataDetail.item.discount_unit" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" min="0" @keypress="isCurrency($event,dataDetail.item.discount_percent)" class="input_width" label="ส่วนลด(%)" hide-details="auto" v-model="dataDetail.item.discount_percent" outlined></v-text-field>
                      </div>
                    </td>
                    <td>{{ format_price(dataDetail.item.total = (( (dataDetail.item.price) - ((dataDetail.item.price * dataDetail.item.discount_percent) / 100)) * dataDetail.item.amount) - dataDetail.item.discount_unit) }}</td>
                    <td class="pa-3">
                      <v-btn small type="button" height="42" @click="getDelete(dataDetail.item.loop_id)" class="grad-danger-bg white--text mb-1">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="13">
                      <div class="grid_total">
                        <div class="pa-5 text-right grid_none" style="font-size: 22px">รวม</div>
                        <div class="pa-5 text-right" style="font-size: 24px">{{ total_grand = total_final }}</div>
                        <div class="pa-5 text-center grid_none" style="font-size: 22px">บาท</div>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div class="pa-4 text-right">
              <v-btn x-large type="submit" class="grad-success-bg white--text btn_mobile" style="font-size: 18px">บันทึกรายการใบสั่งซื้อ</v-btn>
            </div>
          </v-form>
        </div>
        <v-dialog v-model="product_history" max-width="1000">
          <v-card>
            <div v-if="loading_product === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-form ref="add_form" @submit.prevent="">
                <v-card-text>
                  <div class="grid_half_input">
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="รหัสสินค้า" prepend-inner-icon="mdi-cart-outline" hide-details="auto" v-model="get_product_code" outlined></v-text-field>
                    </div>
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="ชื่อสินค้า" prepend-inner-icon="mdi-form-textbox" hide-details="auto" v-model="get_product_name" outlined></v-text-field>
                    </div>
                  </div>
                </v-card-text>
                <v-card-title>
                  <v-text-field v-model="search_green" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                </v-card-title>
                <div class="pa-4">
                  <v-data-table :headers="headers" :items="history_list" :search="search_green" :footer-props="footer_Props" mobile-breakpoint="0" items-per-page="100">
                    <template v-slot:item="dataDetail">
                      <tr>
                        <td>{{ dataDetail.item.receipt_date }}</td>
                        <td>{{ dataDetail.item.supplier_name }}</td>
                        <td>{{ format_number(dataDetail.item.quantity) }}</td>
                        <td>{{ dataDetail.item.unit_name }}</td>
                        <td>{{ format_price(dataDetail.item.price) }}</td>
                        <td>{{ format_price(dataDetail.item.discount_price) }}</td>
                        <td>{{ format_price(dataDetail.item.cost) }}</td>
                        <td class="pa-3">
                          <div class="ml-3 mt-n1">
                            <v-btn @click="append_item(dataDetail.item.supplier_id, dataDetail.item.quantity,dataDetail.item.unit_id ,dataDetail.item.price, dataDetail.item.discount_unit, dataDetail.item.discount_percent)" class="white--text grad-success-bg rounded pl-1 pr-1" title="เลือก">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn x-large class="white--text grad-warning-bg ma-2 pa-6" width="20%" type="button" @click="product_history = false">ย้อนกลับ</v-btn>
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="companyName" max-width="1000">
          <v-card>
            <div v-if="loading_supplier === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-form ref="add_form" @submit.prevent="">
                <v-card-title>
                  {{ company_title }}
                </v-card-title>

                <v-card-title>
                  <v-text-field v-model="search_orange" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                </v-card-title>
                <div class="pa-4">
                  <v-data-table :headers="nameHeaders" key="index" :items="supplier_list" :search="search_orange" :footer-props="footer_Props" mobile-breakpoint="0">
                    <template v-slot:item="dataDetail">
                      <tr>
                        <td>{{ dataDetail.index + 1 }}</td>
                        <td>{{ dataDetail.item.product_name }}</td>
                        <td>{{ dataDetail.item.quantity }}</td>
                        
                        <td>{{ dataDetail.item.unit }}</td>
                        <td class="pa-3">
                          <div class="ml-3 mt-n1">
                            <v-btn @click="addPurchase(dataDetail.item.product_id)" class="white--text grad-success-bg rounded pl-1 pr-1" title="เพิ่ม">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn x-large class="white--text grad-warning-bg ma-2 pa-6" width="20%" type="button" @click="companyName = false">ย้อนกลับ</v-btn>
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatNumber, formatPrice, minDate, onlyForCurrency, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      loading_supplier: false,
      loading_product: false,
      menu_date: false,
      start_date: this.min_date(),
      date: this.diffTH(this.min_date()),
      dateEN: '',
      search: '',
      search_green: '',
      search_orange: '',
      alert_success: false,
      alert_danger: false,
      name: null,
      total_grand: null,
      check_supplier: null,
      product_history: false,
      companyName: false,
      unit: null,
      company_title: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      purchaseHeaders: [
        {
          text: 'PO เครดิต',
          value: 'status_credit',
          fixed: true,
          width: '130px',
          sortable: false
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '300px',
        },
        {
          text: '',
          value: '',
          fixed: true,
          width: '80px',
          sortable: false
        },
        {
          text: 'หน่วยนับ',
          value: 'units',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '250px',
        },
        {
          text: '',
          value: '',
          fixed: true,
          width: '80px',
          sortable: false
        },
        {
          text: 'ในคลัง',
          value: 'count_warehouse',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'amount',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคา',
          value: 'price',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '180px'
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '180px'
        },
        {
          text: 'รวม',
          value: 'total',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ลบ',
          value: '',
          fixed: true,
          width: '50px',
          sortable: false
        },
      ],
      headers: [
        {
          text: 'วันที่',
          value: 'receipt_date',
          fixed: true,
          width: '100px',
        },
        {
          text: 'บริษัท',
          value: 'supplier_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '110px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '110px',
        },

        {
          text: 'ราคาต่อหน่วย',
          value: 'price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'รวม',
          value: 'discount_price',
          fixed: true,
          width: '110px',
        },
        {
          text: 'ต้นทุน',
          value: 'cost',
          fixed: true,
          width: '110px',
        },
        {
          text: '',
          value: '',
          fixed: true,
          width: '',
        },
      ],
      nameHeaders: [
        {
          text: 'ลำดับ',
          value: 'index'
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name'
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity'
        },
        {
          text: 'หน่วยนับ',
          value: 'unit'
        },
        {
          text: '',
          value: ''
        },
      ],
      supplier_list: [],
      getProduct: [],
      loop_id: 0,
      purchase_list: [],
      count_warehouse: null,
      id_product: null,
      data_list: [],
      history_list: [],
      product_lists: [],
      product_suppliers: [],
      import_product_list: [],
      pop_value: null,
      pop_supplier: null,
      get_loop: null,
      get_product_code: null,
      get_product_name: null,
    }
  },
  methods: {
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'-'+month+'-'+year
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    updatePriceByUnit(item) {
      const selected = item.product_lists.find(unit => unit.unit_id === item.units);

      if (selected && item.price_base) {
        item.price = parseFloat(item.price_base) * parseFloat(selected.unit_qty);
      }
    },
    getProductList() {
      this.loading_page = true
      HTTP.post('/purchaseorders/products')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.getProduct = res.data.products
            }
          })
    },
    async addPurchase(id_product) {
      await HTTP.post('/purchaseorders/getsupsandunits', {
        product_id: id_product
      }).then((res) => {
        if (res.data.success === true) {
          this.product_lists = res.data.product_lists
          this.count_warehouse = res.data.count_warehouse
          this.product_suppliers = res.data.product_suppliers
          if (res.data.import_product_lists !== null) {
            this.import_product_list = res.data.import_product_lists
          } else {
            this.import_product_list = {
              quantity: null,
              cost: null,
              discount_unit: null,
              discount_percent: null,
            }
          }
          let supplier_cut = this.product_suppliers.map((data) => {return data.sup_id})
          this.pop_supplier = supplier_cut.shift()
          let value_cut = this.product_lists.map((data) => {return data.unit_id})
          this.pop_value = value_cut.shift()
        }
      })
      let value = this.getProduct.filter((res) => {
        return res.id == id_product
      });
      value.forEach((details) => {
        const id = this.loop_id +=1;
        this.purchase_list.push({
          count_warehouse:this.count_warehouse,
          status_credit: true,
          loop_id: id,
          product_id: details.id,
          product_code: details.product_code,
          name: details.name,
          product_lists: this.product_lists.filter(item => item.is_delete === 0),
          units: this.pop_value,
          product_suppliers: this.product_suppliers,
          supplier: this.pop_supplier,
          supplier_name: null,
          amount: this.import_product_list.quantity,
          price_base: this.import_product_list.cost,      // 👈 เพิ่มบรรทัดนี้
          price: this.import_product_list.cost,   
          discount_unit: this.import_product_list.discount_unit,
          discount_percent: this.import_product_list.discount_percent,
          total: 0,
          type_vat: 1,
          type_purchase: 1,
          show_input: 0,
        })
      })
      await this.$nextTick(() => {
        this.id_product = null;
        this.alert_success = true;
        setTimeout(() => this.alert_success = false, 2000);
      })
    },
    async add_item(product_id) {
      await HTTP.post('/purchaseorders/getsupsandunits', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.product_lists = res.data.product_lists
          this.product_suppliers = res.data.product_suppliers
          this.import_product_list = res.data.import_product_lists
          let supplier_cut = this.product_suppliers.map((data) => {return data.sup_id})
          this.pop_supplier = supplier_cut.shift()
          let value_cut = this.product_lists.map((data) => {return data.unit_id})
          this.pop_value = value_cut.shift()
        }
      })
      await HTTP.post('/purchaseorders/getproductbyid', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          let value = res.data.object
          const id = this.loop_id +=1;
          this.purchase_list.push({
            status_credit: false,
            loop_id: id,
            product_id: value.id,
            product_code: value.product_code,
            name: value.name,
            product_lists: this.product_lists,
            units: this.pop_value,
            product_suppliers: this.product_suppliers,
            supplier: this.pop_supplier,
            supplier_name: null,
            amount: this.import_product_list.quantity,
            price_base: this.import_product_list.cost,      // 👈 เพิ่มบรรทัดนี้
            price: this.import_product_list.cost,    
            discount_unit: this.import_product_list.discount_unit,
            discount_percent: this.import_product_list.discount_percent,
            total: 0,
            type_vat: 1,
            type_purchase: 1,
            show_input: 0,
          })
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 2000);
        }
      })
    },
    getDelete(loop_id) {
      this.alert_danger = true;
      setTimeout(() => this.alert_danger = false, 1000);
      this.purchase_list = this.purchase_list.filter(detail => detail.loop_id !== loop_id);
      // อัปเดต localStorage หลังจากลบ
      if (this.purchase_list.length === 0) {
        this.clearLocalStorage();
      } else {
        this.saveToLocalStorage();
      }
    },
    // append_item(supplier_id, quantity, unit, price, discount_unit, discount_percent) {
    //   const key = this.get_loop
    //   this.purchase_list.forEach((data) => {
    //     if (key === data.loop_id) {
    //       data.supplier = parseInt(supplier_id)
    //       data.amount = parseInt(quantity)
    //       data.price = parseInt(price)
    //       data.units = unit
    //       if (discount_unit !== null) {
    //         data.discount_unit = parseInt(discount_unit)
    //       } else {
    //         data.discount_unit = ''
    //       }
    //       if (discount_percent !== null) {
    //         data.discount_percent = parseInt(discount_percent)
    //       } else {
    //         data.discount_percent = ''
    //       }
           
    //     }
    //   })
    //   this.product_history = false
    //   this.alert_success = true
    //   setTimeout(() => this.alert_success = false, 2000)
    // },
    
    async append_item(supplier_id, quantity, unit, price, discount_unit, discount_percent) {
      const currentItem = this.purchase_list.find((item) => item.loop_id === this.get_loop);
      if (!currentItem) return;

      const newId = this.loop_id += 1;

      this.purchase_list.push({
        ...JSON.parse(JSON.stringify(currentItem)), // ทำ deep copy
        loop_id: newId,
        supplier: parseInt(supplier_id),
        amount: parseInt(quantity),
        price: parseFloat(price),
        units: unit,
        discount_unit: discount_unit !== null ? parseFloat(discount_unit) : '',
        discount_percent: discount_percent !== null ? parseFloat(discount_percent) : '',
      });

      this.product_history = false;
      this.alert_success = true;
      setTimeout(() => (this.alert_success = false), 2000);
    },

    
    async getHistory(loop_id, product_id, product_code, product_name) {
      this.get_product_code = product_code
      this.get_product_name = product_name
      this.get_loop = loop_id
      this.product_history = true
      this.loading_product = true
      await HTTP.post('/purchaseorders/gethistoryimport', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_product = false
          this.history_list = res.data.object
        }
      })
    },
    async getCompany(supplier_id) {
      this.companyName = true
      this.loading_supplier = true
      await HTTP.post('/purchaseorders/getproductbysupplierid', {
        supplier_id: supplier_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_supplier = false
          this.supplier_list = res.data.object
          if (res.data.object.length !== 0) {
            this.company_title = res.data.object[0].supplier
          }
        }
      })
    },
    store_productList() {
      if (this.purchase_list !== '') {
        if (this.$refs.save_list.validate()) {
          this.purchase_list.forEach((data) => {
            this.check_supplier = data.supplier
          })
          if (this.check_supplier != null) {
            Swal.fire({
              title: 'ต้องการดำเนินการต่อหรือไม่ ?',
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((res) => {
              if (res.isConfirmed === true) {
                this.purchase_list.forEach((data) => {
                  let result = data.product_suppliers.find((supplier) => {
                    return supplier.sup_id == data.supplier
                  })
                  if (data.status_credit == true) {
                    data.status_credit = 1;
                  } else if (data.status_credit == false) {
                    data.status_credit = 0;
                  }
                  this.data_list.push({
                    status_credit: data.status_credit,
                    product_id: data.product_id,
                    product_code: data.product_code,
                    name: data.name,
                    product_lists: data.product_lists,
                    units: data.units,
                    product_suppliers: data.product_suppliers,
                    supplier: result.sup_id,
                    supplier_name: result.sup_name,
                    amount: data.amount,
                    price: data.price,
                    discount_unit: data.discount_unit,
                    discount_percent: data.discount_percent,
                    total: data.total,
                    type_vat: 1,
                    show_input: data.show_input,
                  })
                })
                // console.log(this.data_list)
                this.$store.commit('purchase_add', {
                  purchase_list: this.data_list,
                  date: this.date,
                })
               
                // บันทึกข้อมูลลง localStorage ก่อนไปหน้าถัดไป
                this.saveToLocalStorage();
               
                this.$router.push('/confirmaddpurchase')
              }
            })
          }else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'กรุณาเลือก Supplier !',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }
      }else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'เนื่องจาก ไม่มีข้อมูลหรือกรอกข้อมูลไม่ครบ',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    ChangeInput(id) {
      const find_data = this.purchase_list.find((data) => {
        return data.loop_id == id
      })
      if (find_data.show_input == 0) {
        find_data.show_input = 1
      }
      else if (find_data.show_input == 1) {
        find_data.show_input = 0
      }
    },
     formatTwoDecimals(value) {
      return Number(value).toFixed(2)
    },
    // บันทึกข้อมูลลง localStorage
    saveToLocalStorage() {
      try {
        const dataToSave = {
          purchase_list: this.purchase_list,
          date: this.date,
          dateEN: this.dateEN,
          loop_id: this.loop_id,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('purchase_order_draft', JSON.stringify(dataToSave));
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    },
    // โหลดข้อมูลจาก localStorage
    loadFromLocalStorage() {
      try {
        const savedData = localStorage.getItem('purchase_order_draft');
        if (savedData) {
          const parsed = JSON.parse(savedData);
          // ถามผู้ใช้ว่าต้องการโหลดข้อมูลที่บันทึกไว้หรือไม่
          Swal.fire({
            title: 'พบข้อมูลที่บันทึกไว้',
            text: 'ต้องการโหลดข้อมูลที่บันทึกไว้ก่อนหน้านี้หรือไม่?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'โหลดข้อมูล',
            cancelButtonText: 'ไม่โหลด',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              this.purchase_list = parsed.purchase_list || [];
              this.date = parsed.date || this.date;
              this.dateEN = parsed.dateEN || '';
              this.loop_id = parsed.loop_id || 0;
              this.alert_success = true;
              setTimeout(() => (this.alert_success = false), 2000);
            } else {
              // ถ้าไม่โหลด ให้ลบข้อมูลเก่าออก
              this.clearLocalStorage();
            }
          });
        }
      } catch (error) {
        console.error('Error loading from localStorage:', error);
      }
    },
    // ลบข้อมูลจาก localStorage
    clearLocalStorage() {
      try {
        localStorage.removeItem('purchase_order_draft');
      } catch (error) {
        console.error('Error clearing localStorage:', error);
      }
    },
    // ล้างข้อมูลทั้งหมด (ทั้งในหน้าและ localStorage)
    clearAllData() {
      Swal.fire({
        title: 'ยืนยันการล้างข้อมูล',
        text: 'คุณต้องการล้างข้อมูลทั้งหมดหรือไม่? ข้อมูลจะไม่สามารถกู้คืนได้',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ล้างข้อมูล',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.purchase_list = [];
          this.loop_id = 0;
          this.clearLocalStorage();
          this.alert_success = true;
          setTimeout(() => (this.alert_success = false), 2000);
        }
      });
    }
  },
  computed: {
    total_final() {
      let purchase_list = this.purchase_list;
      const result = purchase_list.reduce((sum, number) => {
        let total = (number.amount * number.price);
        let discount_per = (number.amount * ((number.price * number.discount_percent) / 100));
        let total_final = (total - number.discount_unit)
        return sum+(total_final - discount_per);
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.getProductList();
    // โหลดข้อมูลจาก localStorage เมื่อกลับมาหน้าเดิม
    this.loadFromLocalStorage();
  },
  created() {
    window.addEventListener('beforeunload', function (event) {
      event.preventDefault();
      event.returnValue = '';
    })
  },
  watch: {
    // บันทึกข้อมูลลง localStorage ทุกครั้งที่มีการเปลี่ยนแปลง purchase_list
    purchase_list: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.saveToLocalStorage();
        }
      },
      deep: true
    },
    // บันทึกวันที่เมื่อมีการเปลี่ยนแปลง
    date: {
      handler(newVal) {
        if (newVal) {
          this.saveToLocalStorage();
        }
      }
    }
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_half_input {
  display: grid;
  grid-template-columns: 30% 30%;
}
.grid_total {
  display: grid;
  grid-template-columns: 80% 10% 10%;
}
@media only screen and (max-width: 1100px) {
  .grid_total {
    display: grid;
    grid-template-columns: 60% 20% 20%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
